<template>
  <div>
    <h5>Información de transportación</h5>
    <v-card  v-if="!useTransportacion"  outlined>
      <v-card-title class="text-h5">
        <v-icon>mdi-van-passenger</v-icon> Transportación
      </v-card-title>

      <v-card-subtitle>
        Deseas incluir la transportación a la reserva?
      </v-card-subtitle>

      <v-card-actions>
        <v-btn text @click="useTransportacion = true">
          Agregar datos de transporte
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-form v-show="useTransportacion && !appliedTransportacion" ref="transportacionForm">
      <v-row>
        <v-col cols="12" md="8">
          <v-autocomplete
            label="Hotel"
            prepend-icon="mdi-hospital-marker"
            :items="hotelesEP"
            v-model="dataForm.Hotel.id"
            @input="onChangeHotel()"
            item-text="label"
            item-value="Id"
            outlined
            dense
            required
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            label="Pax"
            v-model="dataForm.Pax"
            prepend-icon="mdi-account"
            outlined
            dense
            required
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4" class="mt-n8">
        <v-text-field
            label="Pickup"
            prepend-icon="mdi-clock-outline"
            v-mask="'##:##'"
            v-model="dataForm.Pickup"
            outlined
            dense
            required
          ></v-text-field>
        
          
        </v-col>
        <v-col cols="12" md="4" class="mt-n8">
         <v-text-field
            v-if="!dataForm.OW"
            label="Drop off"
            v-mask="'##:##'"
            prepend-icon="mdi-clock"
            outlined
            v-model="dataForm.DropOff"
            dense
            required
          ></v-text-field>
        
         
        </v-col>
        <v-col cols="12" md="4" class="mt-n8">
          <v-switch v-model="dataForm.OW" label="One way" outlined class="mt-1" required></v-switch>
        </v-col>
        <v-col cols="12" md="4" class="mt-n8">
          <v-text-field
            label="Habitación (opcional)"
            v-model="dataForm.Room"
             prepend-icon="mdi-city"
            outlined
            dense
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4" class="mt-n8">
          <v-text-field
            label="Lobby (opcional)"
            v-model="dataForm.Lobby"
            prepend-icon="mdi-home-city"
            outlined
            dense
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4" class="mt-n8">
          <v-text-field
            label="Folio (opcional)"
            v-model="dataForm.Confirmation"
            prepend-icon="mdi-numeric"
            outlined
            dense
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4" class="mt-n8">
          <v-text-field
            label="Precio Transporación"
            v-model="dataForm.Price.C"
            prepend-icon="mdi-currency-usd"
            outlined
            dense
            required
          ></v-text-field>
        </v-col>
         <v-col cols="12" md="4" class="mt-n8">
          <v-select
            v-model="dataForm.Price.M"
            prepend-icon="mdi-currency-usd"
            label="Moneda"
            :items="getPDVMonedasLista"
            item-value="id"
            item-text="Nombre"
            outlined
            dense
          >
          </v-select>
        </v-col>
        <v-col cols="12" md="4" class="mt-n8">
          <v-switch v-model="dataForm.TripCharge" label="Precio por viaje" outlined class="mt-1" required></v-switch>
        </v-col>
      </v-row>
      <div style="float:right;">
        <v-btn large outlined @click="deleteTransportation()">Sin Transportacion</v-btn>
        <v-btn outlined @click="aplyTransportacion()" style="margin-left: 6px" color="green" large
          >Aplicar Transportación</v-btn
        >
      </div>
    </v-form>
    <v-card  v-if="appliedTransportacion"  outlined>
      <v-card-title class="text-h5">
        <v-icon>mdi-van-passenger</v-icon> Transportación Registrada
      </v-card-title>

      <v-card-subtitle>
        <b>{{dataForm.OW?"One Way":"Round Trip"}}</b><br/>
        Hora de pickup:  {{dataForm.Pickup}} Hora de drop off:{{dataForm.DropOff}} <br/>
        Hotel: <b>{{dataForm.Hotel.nm}}</b> <br/>
        Pax:<b>{{dataForm.Pax}}</b><br/>
        <b>{{dataForm.Confirmation != ''?"Folio:"+dataForm.Confirmation:""}}</b><br/>
        <b>{{dataForm.Room != ''?"Habitacion:"+dataForm.Room:""}}</b><br/>
        <b>{{dataForm.Lobby != ''?"Lobby:"+dataForm.Lobby:""}}</b><br/>
      </v-card-subtitle>

      <v-card-actions>
        <v-btn text @click="appliedTransportacion = false">
          Editar
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import moment from "moment";
import axiosCore from "axios";
import { mapGetters } from "vuex";
export default {
  name: "TransportacionForm",
  components: {},
  props: [
    "edit",
    "dataEdit",
    "paxNumber",
    "fecha", "time"
    ],
  data() {
    return {
      useTransportacion:false,
      appliedTransportacion:false,
      hotelesEP: [],
      dataForm:{
        Pax:0,
        Hotel:{
          nm:"",
          id:""
        },
        hotel:"",
        hotelName:"",
        Pickup:"",
        DropOff:"",
        OW:false,
        Room:"",
        Lobby:"",
        Confirmation:"",
        Price:{
          C:10,M:"USD"
        },
        TripCharge:false,

      }
    };
  },
  methods: {
    intiForm(data){
      if(data){
        this.useTransportacion=true
        this.appliedTransportacion=false
        this.dataForm = data
      }
    },
    onChangeHotel(){
        let exist = this.$pgsHelper.getById(this.hotelesEP,"Id",this.dataForm.Hotel.id);
        if(exist){
          this.dataForm.Hotel.nm = exist.label
        }
    },
    deleteTransportation(){
      this.useTransportacion = false
      this.$emit("onChangeTransportationData",this.$data)
    },
    aplyTransportacion(){
      //let dataHotel = this.$pgsHelper.getById(this.hotelesEP,"Id",this.dataForm.hotel)
      //his.dataForm.hotelName = dataHotel.label
      if(this.dataForm.OW){
        this.dataForm.DropOff = null
      }
      this.dataForm.Pax =  Number(this.dataForm.Pax)
      this.dataForm.Price.C = Number(this.dataForm.Price.C)
      this.appliedTransportacion=true
      this.$emit("onChangeTransportationData",this.$data)
    },
    async getEpHotel() {
      let axiosInstance = axiosCore.create({
        headers: {
          "Content-Type": "text/plain",
        },
        transformRequest: (data) => {
          return JSON.stringify(data);
        },
      });
      let urlEp =
        "https://www.entertainment-plus.net/get_hotels_deeplink?term=' '";
      const response = await axiosInstance.get(urlEp);
      this.hotelesEP = response.data;
    },
  },
  computed: {
    ...mapGetters([
      "getPDVMonedasLista",

    ]),
  },
  watch: {
  },
  beforeMount: function() {
    this.loader = true; 
  },
  mounted() {
    this.getEpHotel();
    if(this.dataForm.Pax == 0){
      this.dataForm.Pax = this.paxNumber;
    }
    if(this.dataForm.Pickup != ""){
      this.dataForm.Pickup = moment(this.time, "HH:mm").format("HH:mm")
      this.dataForm.DropOff = moment(this.time, "HH:mm").format("HH:mm")
    }
    this.loader = false;
  },
};
</script>
